import React from 'react';

export interface SectionHeaderProps {
  /**
   * Title text or element.
   *
   * `React.ReactElement` values are not affected by `as`, `id`,
   * `aria-describedby`, and `size` props or default text styling.
   */
  title: React.ReactNode;

  /** Suffix content. */
  suffix?: React.ReactNode;

  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook?: string;

  /** Skin variant. */
  skin?: SectionHeaderSkin;

  /** Renders component as any other component or a given HTML tag. */
  as?: SectionHeaderTitleAs;

  /** Title text element id. */
  id?: string;

  /** Title text element label reference id. */
  'aria-describedby'?: string;

  /** Title size. */
  size?: SectionHeaderTitleSize;

  /** Title alignment. */
  align?: SectionHeaderTitleAlignment;

  /** Divider type. */
  divider?: SectionHeaderDivider;

  /** Horizontal padding. */
  horizontalPadding?: SectionHeaderHorizontalPadding;
}

export type SectionHeaderTitleAs =
  | 'span'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6';

export type SectionHeaderSkin = 'standard' | 'neutral';

export type SectionHeaderTitleSize = 'small' | 'medium';

export type SectionHeaderTitleAlignment = 'start' | 'center';

export type SectionHeaderDivider = 'default' | 'top' | 'bottom' | 'none';

export type SectionHeaderHorizontalPadding =
  | 'large'
  | 'medium'
  | 'small'
  | 'tiny'
  | 'xTiny'
  | 'xxTiny';
